(function () {
  if (window.__mobileMenuBound) return;
  window.__mobileMenuBound = true;

  var CLOSE_MS = 420;
  var closeTimers = new WeakMap();

  function closestMenu(el) {
    var root = el.closest('[data-mobile-menu-root]') || document;
    return root.querySelector('[data-mobile-menu]');
  }

  function closestToggle(menu) {
    var root = menu.closest('[data-mobile-menu-root]') || document;
    return root.querySelector('[data-mobile-menu-toggle]');
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clearCloseTimer(menu) {
    var timer = closeTimers.get(menu);
    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(menu);
    }
  }

  function setOpen(menu, open) {
    if (!menu) return;

    var isOpen = menu.classList.contains('is-open');
    var isClosing = menu.classList.contains('is-closing');
    if (open && isOpen && !isClosing) return;
    if (!open && !isOpen && !isClosing) return;

    clearCloseTimer(menu);

    if (open) {
      menu.hidden = false;
      menu.classList.remove('is-closing');
      document.body.classList.add('mobile-menu-open');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          menu.classList.add('is-open');
        });
      });
    } else {
      menu.classList.remove('is-open');
      menu.classList.add('is-closing');
      document.body.classList.remove('mobile-menu-open');

      function finishClose() {
        menu.classList.remove('is-closing');
        menu.hidden = true;
        closeTimers.delete(menu);
      }

      if (prefersReducedMotion()) {
        finishClose();
      } else {
        closeTimers.set(menu, setTimeout(finishClose, CLOSE_MS));
      }
    }

    var toggle = closestToggle(menu);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mobile-menu-toggle]');
    if (toggle) {
      var menu = closestMenu(toggle);
      setOpen(menu, !menu.classList.contains('is-open'));
      return;
    }

    if (e.target.closest('[data-mobile-menu-close]')) {
      var menu = e.target.closest('[data-mobile-menu]') || document.querySelector('.mobile-menu.is-open');
      setOpen(menu, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu.is-open').forEach(function (menu) {
      setOpen(menu, false);
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.mobile-menu.is-open').forEach(function (menu) {
      var root = menu.closest('[data-mobile-menu-root]');
      var bp = (root && root.getAttribute('data-mobile-menu-breakpoint')) || '1368';
      if (window.matchMedia('(min-width: ' + bp + 'px)').matches) {
        setOpen(menu, false);
      }
    });
  });
})();
